/**
 * 设备判断与 PC/移动版切换。
 *
 * 判断用 UA + 屏幕宽度双条件：
 *   只看 UA  → iPad、安卓平板会被误判成手机，但它们用 PC 版体验更好
 *   只看宽度 → PC 上把窗口拖窄会被误判成手机，很怪
 * 两个都满足才当手机。
 *
 * 用户手动选择永远优先于自动判断，选择记在 localStorage.viewMode。
 */

const VIEW_MODE_KEY = 'viewMode'
const MOBILE_UA = /Android|iPhone|iPod|BlackBerry|IEMobile|Opera Mini|Mobile|HarmonyOS/i
// 820 是 iPad 竖屏宽度，取这个值让 iPad 走 PC 版
const MOBILE_MAX_WIDTH = 820

/**
 * 当前设备是否为手机
 * @returns {boolean}
 */
export function isMobileDevice() {
  if (typeof window === 'undefined') return false
  const uaHit = MOBILE_UA.test(navigator.userAgent)
  const widthHit = window.innerWidth <= MOBILE_MAX_WIDTH
  return uaHit && widthHit
}

/**
 * 用户手动选择的版本
 * @returns {'pc'|'mobile'|null} null 表示没手动选过，走自动判断
 */
export function getViewMode() {
  try {
    const v = localStorage.getItem(VIEW_MODE_KEY)
    return v === 'pc' || v === 'mobile' ? v : null
  } catch (e) {
    // 隐私模式下 localStorage 可能抛异常
    return null
  }
}

export function setViewMode(mode) {
  try {
    if (mode) localStorage.setItem(VIEW_MODE_KEY, mode)
    else localStorage.removeItem(VIEW_MODE_KEY)
  } catch (e) {
    // 存不进去就算了，本次会话仍按自动判断走
  }
}

/**
 * 最终是否应该用移动版：手动选择优先，没选过才看设备
 * @returns {boolean}
 */
export function shouldUseMobile() {
  const mode = getViewMode()
  if (mode === 'pc') return false
  if (mode === 'mobile') return true
  return isMobileDevice()
}

/** 是否是移动端路由 */
export function isMobileRoute(path) {
  return path === '/m' || path.indexOf('/m/') === 0
}

/** 只看 UA，不看宽度。用于「这台设备是不是手机」，和「该不该显示移动版」无关 */
export function isMobileUA() {
  if (typeof window === 'undefined') return false
  return MOBILE_UA.test(navigator.userAgent)
}

const VIEWPORT_MOBILE =
  'width=device-width,initial-scale=1.0,maximum-scale=1.0,user-scalable=no,viewport-fit=cover'
// PC 页面写死 1224px 宽，手机上按 device-width 渲染必然横向溢出，
// 而 user-scalable=no 又不让缩放，等于卡死。给固定宽度让浏览器整体缩小，
// 并放开手势缩放 —— 就是普通桌面站在手机上的正常表现。
const VIEWPORT_PC = 'width=1224,user-scalable=yes'

/**
 * 按当前显示的是哪一版切换 viewport。
 * 只在手机 UA 下改动 —— 桌面浏览器压根不解析 viewport，
 * 但限制住能保证 PC 端行为一个字节都不变。
 * @param {boolean} isMobilePage 当前展示的是否为移动端页面
 */
export function applyViewport(isMobilePage) {
  if (typeof document === 'undefined' || !isMobileUA()) return
  const el = document.querySelector('meta[name="viewport"]')
  if (!el) return
  const want = isMobilePage ? VIEWPORT_MOBILE : VIEWPORT_PC
  if (el.getAttribute('content') !== want) el.setAttribute('content', want)
}



// WEBPACK FOOTER //
// ./src/utils/device.js